import ReactGA from 'react-ga4';
import services from 'services/services';

// Import variables
import { TRACKING_TYPES } from '../variables';
const { GA } = TRACKING_TYPES;

const validKeyRegex = new RegExp(/G-.{10}/, 'g');
// G-XXXXXXXXXX

export const initGA = async () => {
	try {
		const {
			data: { value }
		} = await services.get(`/settings/codes/${GA}`);
		if (value && validKeyRegex.exec(value)) {
			ReactGA.initialize(value);
		} else
			console.warn(
				`Provided ${GA} key is invalid or missing, check your CMS settings`
			);
	} catch {
		console.error(`Could not fetch your ${GA} key`);
	}
};
